import Phase from 'actions/phase';

export default Phase.createReducer();